import { mapActions, mapGetters } from 'vuex';

export const PinFilterHelper = {
  computed: {
    ...mapGetters('userPreferencesStore', ['getPinFilter']),
    pinFilter: {
      get(this: any): boolean {
        return this.getPinFilter(this.workflowQueueDataModel.queueId);
      },
      set(this: any, value: boolean) {
        this.setPinFilter({ queueId: this.workflowQueueDataModel.queueId, pinFilter: value || false });
      }
    }
  },
  methods: {
    ...mapActions('userPreferencesStore', ['setPinFilter'])
  }
};
